import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';
import { useGetPayerMixV2Query } from 'src/api/redux';
import useProfileSelections from 'src/hooks/profiles/useProfileSelections';

interface UseNewGetPayerMixProps {
  providerId: string;
  groupBy: string;
  location?: string;
  filterSetId?: string | number;
}

const useNewGetPayerMix = ({
  providerId,
  groupBy,
  location,
  filterSetId,
}: UseNewGetPayerMixProps) => {
  const { selectedFilterSet, isAllCodeSets } = useProfileSelections(location);

  const params = {
    filter_set: filterSetId ?? selectedFilterSet?.id,
    all_code_sets: filterSetId ? false : isAllCodeSets,
  };

  const queryParams = getSearchQueryParamsForAPI({
    group_by: groupBy,
    ...params,
  });

  const shouldFetch = !!location && !!providerId;

  const { data, error, isLoading, isFetching } = useGetPayerMixV2Query(
    { providerId, queryParams },
    { skip: !shouldFetch }
  );

  return {
    data,
    error,
    isLoading,
    isValidating: isFetching,
  };
};

export default useNewGetPayerMix;
